import { create } from "zustand";
import lang_en from "../locales/en.json";
import { persist } from "zustand/middleware";

const supportLanguageStore = (set) => ({
  language: lang_en,
  changeLanguage: async (newLanguage) => {
    let langModule;
    try {
      switch (newLanguage) {
        case "FRA":
          langModule = await import("../locales/fr.json");
          break;
        case "ENG":
          langModule = await import("../locales/en.json");
          break;
        case "SPA":
          langModule = await import("../locales/es.json");
          break;
        case "ITA":
          langModule = await import("../locales/it.json");
          break;
        case "DEU":
          langModule = await import("../locales/de.json");
          break;
        default:
          langModule = await import("../locales/en.json");
          break;
      }
      set({ language: langModule.default });
    } catch (error) {
      console.error("Failed to load language file", error);
    }
  },
});

export const useSupportLanguage = create(persist(supportLanguageStore, { name: "support_locale" }));
